import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';
import { useMedia } from 'react-use';
import { useContainerStore } from '@/hooks/useGlobalStore.ts';

interface DeviceFrameProps {
  children: ReactNode;
}

export const DeviceFrame = ({ children }: DeviceFrameProps) => {
  const isWide = useMedia('(min-width: 480px)');
  const { setContainer } = useContainerStore();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      setContainer(ref.current);
    }
  }, []);

  if (!isWide) {
    return children;
  }
  return (
    <div className="flex w-full min-h-[100vh] justify-center items-center relative bg-white">
      <div className="w-[430px] relative mx-auto min-h-[100vh] bg-background" ref={ref}>
        {children}
      </div>
    </div>
  );
};
